import type { Currency, Entry } from '@/types/domain'

export type CurrencyTotals = Record<Currency, number>

export interface Totals {
  rendimentos: CurrencyTotals & { BRL: number }
  impostos: CurrencyTotals & { BRL: number }
  liquidoBRL: number
  counts: { rendimentos: number; impostos: number; total: number }
}

const EMPTY_CURRENCY_TOTALS = { USD: 0, CAD: 0 }

/**
 * Aggregates entries by tipo (rendimento vs imposto) and currency, plus a
 * BRL total derived from snapshot.valorBRL. Entries with status != 'calculado'
 * contribute their original-currency totals only (BRL stays at 0).
 */
export function computeTotals(entries: Entry[]): Totals {
  const t: Totals = {
    rendimentos: { ...EMPTY_CURRENCY_TOTALS, BRL: 0 },
    impostos: { ...EMPTY_CURRENCY_TOTALS, BRL: 0 },
    liquidoBRL: 0,
    counts: { rendimentos: 0, impostos: 0, total: 0 },
  }

  for (const entry of entries) {
    const bucket = entry.tipo === 'rendimento' ? t.rendimentos : t.impostos
    bucket[entry.moedaOrigem] = round(bucket[entry.moedaOrigem] + entry.valorOriginal, 4)
    if (entry.snapshot.status === 'calculado' && typeof entry.snapshot.valorBRL === 'number') {
      bucket.BRL = round(bucket.BRL + entry.snapshot.valorBRL, 2)
    }
    if (entry.tipo === 'rendimento') t.counts.rendimentos += 1
    else t.counts.impostos += 1
  }

  t.counts.total = t.counts.rendimentos + t.counts.impostos
  t.liquidoBRL = round(t.rendimentos.BRL - t.impostos.BRL, 2)
  return t
}

function round(value: number, decimals: number): number {
  const factor = 10 ** decimals
  return Math.round(value * factor) / factor
}
